var _circle, _g, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3498db",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#2980b9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1abc9c",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ecf0f1",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "url(#logoGradient)",
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 16,
    rx: 2,
    fill: "url(#iconGradient)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 2 L 24 2 L 20 6 Z",
    fill: "url(#iconGradient)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 14,
    height: 1.5,
    rx: 0.5,
    fill: "#3498db",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6.5,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#3498db",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#3498db",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10.5,
    width: 16,
    height: 0.8,
    rx: 0.4,
    fill: "#7f8c8d",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 14,
    height: 0.8,
    rx: 0.4,
    fill: "#7f8c8d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.5,
    width: 12,
    height: 0.8,
    rx: 0.4,
    fill: "#7f8c8d",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1,
    fill: "#e74c3c",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;0.2;0.8",
    dur: "2s",
    repeatCount: "indefinite"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    fill: "none",
    stroke: "rgba(52,152,219,0.3)",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "18;19;18",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0.8;0.5",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d8be8faa4d036ac93415235bb165a67d.svg";
export { ForwardRef as ReactComponent };